import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useCreateDemoAgendaMutation } from "@store/api/agenda";
import { trackDemoEvent } from "@utils/demoAnalytics";
import { $Routes } from "@routes";
import useToastNotification from "./useToastNotification";

/**
 * Shared entry point for kicking off the interactive demo from any UI surface.
 * Returns { startDemo, isDemoLoading }.
 *
 * @param {Object} options
 * @param {string} [options.source] - Analytics tag identifying which trigger fired.
 */
const useStartDemo = ({ source } = {}) => {
  const navigate = useNavigate();
  const { showErrorToast } = useToastNotification();
  const [createDemoAgenda, { isLoading: isDemoLoading }] =
    useCreateDemoAgendaMutation();

  const startDemo = useCallback(async () => {
    trackDemoEvent("demo_started", source ? { source } : undefined);
    try {
      const response = await createDemoAgenda().unwrap();
      const agendaId = response?.agenda?._id;
      if (agendaId) {
        navigate(`${$Routes.allAgendaPage}/${agendaId}?demo=true`);
        return agendaId;
      }
      return null;
    } catch (error) {
      console.error("Failed to create demo agenda:", error);
      showErrorToast("Failed to start demo. Please try again.");
      return null;
    }
  }, [createDemoAgenda, navigate, showErrorToast, source]);

  return { startDemo, isDemoLoading };
};

export default useStartDemo;
